import First from "../../../../../assets/images/project/rumah/DOD_HOUSE/rumah-dod-thumb.jpg";

export default [
  {
    title: "DOD House",
    description: "Rumah modern minimalis",
    urls: First,
  },
];
